<template>
  <section class="about-us">
    <div class="container">
      <h2>{{ aboutUs.title }}</h2>
      <p v-html="aboutUs.description"></p>
      <div class="d-flex flex-column">
        <AboutUsItem v-for="(aboutUsItem, index) in aboutUs.aboutUsItems" :aboutUsItem="aboutUsItem" :index="index" :key="aboutUsItem.id" />
      </div>
    </div>
  </section>
</template>

<script>
import AboutUsItem from "@/components/about-us/AboutUsItem.vue";

export default {
  components: { AboutUsItem },
  props: {
    aboutUs: {
      title: String,
      description: String,
      aboutUsItems: Array,
    },
  }
}
</script>